module.exports = __webpack_public_path__ + "static/media/back-arrow-header.99549cc9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/back-arrow-header.svg
// module id = 293
// module chunks = 0